export default __webpack_public_path__ + "static/white-black-bananatex-7b2feec5c6802ce7b2c37f6116099159.png";